var map = {
	"./0.png": 16592,
	"./1.png": 22841,
	"./3/0_ko.png": 64053,
	"./3/1_ko.png": 89602,
	"./3/2_ko.png": 56995,
	"./3/3_ko.png": 45488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83736;